// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"ConfirmDeleteModal_modalBackdrop__csPvO","modalContent":"ConfirmDeleteModal_modalContent__6MY-2"};